import { ChatMessagesProps } from '@/interfaces';

export const getChatErrorMessage = (): ChatMessagesProps => {
	// const timestamp = new Date().toLocaleString([], {
	// 	hour: '2-digit',
	// 	minute: '2-digit',
	// 	hour12: true,
	// });

	return {
		message: `
            <div class="flex flex-col gap-3">
                <span data-type="conversation-end" class='p-3 rounded-2xl w-fit rounded-tl-none bg-green-20'>
                    <p class='text-black font-normal text-sm xl:text-sm'>
                      Session Expired, send a new message to resume conversation
                    </p>
                </span>
            </div>
        `,
		role: 'system',
		profile_picture: '/icons/svg/hat-avatar.svg', // Assuming this is Icons.hatAvatar
		first_name: 'ClaimMagic',
		last_name: 'AI',
	};
};
